<template>
  <div class="available-modal-wrapper" @click="closeModal">
    <div class="available-modal">
      <h5>Expiry alert not available.</h5>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // closeModal() {
    //   this.$emit('click');
    // },

    closeModal(e) {
      let target = e.target.className;
      
      if(target.includes('available-modal-wrapper')) {
        document.querySelector('.available-modal-wrapper').style.opacity = '0';
        document.querySelector('.available-modal-wrapper').style.zIndex = '-999';
        document.querySelector('body').style.overflow = 'auto';
      } else if(target.includes('cancel')) {
        document.querySelector('.available-modal-wrapper').style.opacity = '0';
        document.querySelector('.available-modal-wrapper').style.zIndex = '-999';
        document.querySelector('body').style.overflow = 'auto';
      }
    },
  }
}
</script>

<style lang="scss">
  .available-modal-wrapper {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: -999;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .available-modal {
      background: #fff;
      padding: 40px 50px;
      margin-top: 200px;
      box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
      border-radius: 15px;
      width: 600px;
      text-align: center;

      // h5 {
      //   margin-bottom: 40px;
      // }

      .user-actions {
        display: flex;
        justify-content: center;

        .orange-btn {
          width: 170px;
          margin: 0 10px;
          border: none;
          font-family: "Gotham-Book";

          &.cancel {
            background: #ebebeb;
            color: #333;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }
  }
</style>